import { render } from "./ExamRecord.vue?vue&type=template&id=56c9e94c&scoped=true&ts=true"
import script from "./ExamRecord.vue?vue&type=script&lang=ts"
export * from "./ExamRecord.vue?vue&type=script&lang=ts"

import "./ExamRecord.vue?vue&type=style&index=0&id=56c9e94c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c9e94c"]])

export default __exports__